import { cacheDom } from '../utils/QuerySelectors.js'

const dom = {}
const qs = {
  swiper: 'data-media-swiper',
}
const qsAll = {
  sections: 'data-section-type="image-with-text"',
  details: 'data-accordion-details',
}

const initSwiper = (swiperWrapper) => {
  const mobileEffect = {
    effect: 'slide',
  }
  const desktopEffect = {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
  }
  if (swiperWrapper.swiper) swiperWrapper.swiper.destroy(true, true)
  new Swiper(
    swiperWrapper,
    Object.assign(window.innerWidth >= 1024 ? desktopEffect : mobileEffect, {
      navigation: {
        enabled: swiperWrapper.querySelector('.swiper-button-prev') ? true : false,
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }),
  )
}

const initSection = (section) => {
  const details = section.querySelectorAll(`[${qsAll.details}]`)
  details.forEach((detail) => {
    detail.addEventListener('click', () => {
      details.forEach((d) => {
        if (d != detail) d.removeAttribute('open')
      })
    })
  })
  const swiperWrapper = section.querySelector(`[${qs.swiper}]`)
  initSwiper(swiperWrapper)
  window.addEventListener('resize', () => {
    initSwiper(swiperWrapper)
  })
}

export const setupImageWithTexts = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => initSection(section))
}
